import { DEFAULT_TENANT_ID, TENANTS } from './tenants';

// Resolves which tenant is active from the hostname's first label, e.g.
// feelen.esense-eegenius.com -> 'feelen'. Anything that doesn't match a
// configured tenant's `subdomain` (apex domain, www, esense-*.web.app
// Firebase preview URLs, localhost, ...) falls back to DEFAULT_TENANT_ID.
//
// `search` (the URL query string) allows a `?tenant=<id>` override for
// local development and QA against a tenant without needing its real
// subdomain — e.g. http://localhost:4200?tenant=feelen.
export function resolveTenantId(hostname: string, search: string = ''): string {
  const override = new URLSearchParams(search).get('tenant');
  if (override && TENANTS[override]) {
    return override;
  }

  // Strip a leading "www." so www.feelen.esense-eegenius.com resolves like
  // feelen.esense-eegenius.com.
  const firstLabel = (hostname || '').toLowerCase().replace(/^www\./, '').split('.')[0];
  const match = Object.keys(TENANTS).find(
    (id) => id !== DEFAULT_TENANT_ID && TENANTS[id].subdomain === firstLabel
  );
  return match || DEFAULT_TENANT_ID;
}
